import { render, staticRenderFns } from "./ticket-list.vue?vue&type=template&id=a650f1d4&scoped=true&"
import script from "./ticket-list.vue?vue&type=script&lang=js&"
export * from "./ticket-list.vue?vue&type=script&lang=js&"
import style0 from "./ticket-list.vue?vue&type=style&index=0&id=a650f1d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a650f1d4",
  null
  
)

export default component.exports